import { render } from "./WorkspaceSwitcher.vue?vue&type=template&id=e5033ec0&scoped=true"
import script from "./WorkspaceSwitcher.vue?vue&type=script&lang=js"
export * from "./WorkspaceSwitcher.vue?vue&type=script&lang=js"

import "./WorkspaceSwitcher.vue?vue&type=style&index=0&id=e5033ec0&scoped=true&lang=scss"
import "./WorkspaceSwitcher.vue?vue&type=style&index=1&id=e5033ec0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5033ec0"]])

export default __exports__